<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Nome fantasia</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.nome_fantasia"
                    id="nomeFantasia"
                  />
                </div>
                <div class="col-md-12">
                  <label>Razão social</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.razao_social"
                  />
                </div>
                <div class="col-md-3">
                  <label>CNPJ</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'99.999.999./9999-99'"
                    v-model="fabricante.cnpj"
                  />
                </div>
                <div class="col-md-3">
                  <label>CNES</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.cnes"
                  />
                </div>
                <div class="col-md-2">
                  <label>Telefone/Celular</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'(99) 9999-99999'"
                    v-model="fabricante.telefone"
                  />
                </div>
                <div class="col-md-4">
                  <label>Email</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.email"
                  />
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-2">
                  <label>CEP</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'99999-999'"
                    v-model="fabricante.cep"
                    v-on:keyup="buscar"
                  />
                </div>
                <div class="col-md-6">
                  <label>Logradouro</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.logradouro"
                  />
                </div>
                <div class="col-md-2">
                  <label>Número</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.numero"
                    id="inputNumero"
                  />
                </div>
                <div class="col-md-2">
                  <label>Complemento</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.complemento"
                  />
                </div>
                <div class="col-md-4">
                  <label>Bairro</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.bairro"
                  />
                </div>
                <div class="col-md-4">
                  <label>Cidade</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.cidade"
                  />
                </div>
                <div class="col-md-4">
                  <label>Estado</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fabricante.estado"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/fabricantes" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      fabricante: {
        logradouro: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "fabricantes";

      self.$loading(true);

      if (self.fabricante.id) {
        api += "/" + self.fabricante.id;
        self.fabricante._method = "PUT";
      }

      axios
        .post(api, self.fabricante)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/fabricantes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.fabricante.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.fabricante.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.fabricante.logradouro = self.endereco.logradouro;
            self.fabricante.complemento = self.endereco.complemento;
            self.fabricante.bairro = self.endereco.bairro;
            self.fabricante.cidade = self.endereco.localidade;
            self.fabricante.estado = self.endereco.uf;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getFabricantes: function (id) {
      const self = this;
      const api = self.$store.state.api + "fabricantes/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.fabricante = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    $("#nomeFantasia").focus();

    if (id) {
      self.getFabricantes(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>